/** A labelled horizontal slider with a live readout; double-click the readout to snap back. */
export default function MixSlider({ id, label, value, min, max, step, fmt, onChange, resetTo = 0, disabled = false, accent = "accent-cyan-300" }) {
  return (
    <label className="block">
      <span className="mb-1 flex items-center justify-between gap-1 whitespace-nowrap font-mono text-[9px] uppercase tracking-[0.12em] text-white/50">
        {label}
        <button type="button" data-testid={`${id}-value`} onDoubleClick={() => onChange(resetTo)} disabled={disabled} title="Double-click to reset"
          className="whitespace-nowrap rounded px-1 tracking-normal text-white/85 transition-colors duration-150 hover:bg-white/[0.08]">{fmt(value)}</button>
      </span>
      <input type="range" data-testid={id} min={min} max={max} step={step} value={value} disabled={disabled}
        onChange={(e) => onChange(Number(e.target.value))} className={`h-1.5 w-full cursor-pointer ${accent} disabled:cursor-not-allowed disabled:opacity-35`} />
    </label>
  );
}

/** Vertical channel fader (a rotated native range, so keyboard + touch still work). */
export function Fader({ id, value, min = -30, max = 6, step = 0.5, onChange, label }) {
  const pct = ((value - min) / (max - min)) * 100;
  return (
    <div className="relative mx-auto h-44 w-12" title="Double-click to reset to 0 dB" onDoubleClick={() => onChange(0)}>
      <div aria-hidden className="absolute inset-y-1 left-1/2 w-1.5 -translate-x-1/2 overflow-hidden rounded-full bg-white/[0.08]">
        <div className="absolute inset-x-0 bottom-0 rounded-full bg-gradient-to-t from-cyan-400/80 to-blue-400/80" style={{ height: `${pct}%` }} />
      </div>
      <div aria-hidden className="absolute left-0 right-0 border-t border-dashed border-white/25" style={{ bottom: `${((0 - min) / (max - min)) * 100}%` }} />
      <input type="range" data-testid={id} aria-label={label} min={min} max={max} step={step} value={value} onChange={(e) => onChange(Number(e.target.value))}
        className="absolute accent-cyan-300 left-1/2 top-1/2 h-12 w-44 -translate-x-1/2 -translate-y-1/2 -rotate-90 cursor-pointer" />
    </div>
  );
}
